import { publicCustomerPortalViewerClientEngagement } from '@wix/bi-logger-wix-answers/v2';
import * as React from 'react';
import { BiLogger } from '../../../routes/bi';
import { NavLinkJsx } from '../nav-link-jsx';

export const TicketNavLink = ({ model, biLogger }: { model: any; biLogger: BiLogger }) => (
  props,
) => {
  const uri = `/ticket/${props.id}`;

  const onTicketClick = () => {
    return biLogger.report(publicCustomerPortalViewerClientEngagement({
      data: JSON.stringify({
        id: props.id,
        is_ticket_owner: props.isUserReporter,
        is_ticket_cc: props.isUserCC,
      }),
      engaged_component: 'support_request_list',
      engagement_name: 'click_on_link_to_ticket_page',
      answers_brand_id: model.tenant.brandId,
    }));
  };

  return (
    <NavLinkJsx className={props.className} uri={uri} onClick={onTicketClick}>
      {props.children}
    </NavLinkJsx>
  );
};
